import CustomerIncident from "./Items/CustomerIncident";
import { useEffect, useState } from "react";
import { useClickFilter } from "../../hooks/filtering";
import { customerIncidents } from "../../endpoints";
import CustomerIncidentLoading from "./Items/CustomerIncidentLoading";
import useFetch from "../../hooks/useFetch";
import { useSearchBar } from "../../hooks/search";

interface Props {
  name: string;
}

interface incidentsData {
  number: string;
  description: string;
  status: string;
  time: string;
  target_date: string;
  priority: string;
  call_type: string;
  line: string;
  caller_name: string;
  operator: string;
  operator_group: string;
}

const CustomerIncidents = ({ name }: Props) => {
  const { data, loading } = useFetch<incidentsData>(customerIncidents, {
    companyName: name,
  });
  const [showNoIncidents, setShowNoIncidents] = useState(false);

  useEffect(() => {
    if (!loading && data.length === 0) {
      const timer = setTimeout(() => {
        setShowNoIncidents(true);
      }, 150);

      return () => clearTimeout(timer);
    } else {
      setShowNoIncidents(false);
    }
  }, [loading, data]);

  // // Adapt data for filtering hook (statusSort is not in original, so add to hook if needed)
  // const sortableData = data ? data.map(item => ({
  //   ...item,
  //   status: item.status || "",
  //   description: item.description || "",
  //   number: item.number || ""
  // })) : [];
  // const filteredData = getFilteredData(sortableData);

  const {
    searchEntry,
    setSearchEntry,

    setIsSearchFocused,

    handleFilterClick,
    shouldShowFilters,
    searchRef,
    getFilteredSearchProjects,
  } = useSearchBar(data);

  const {
    numberSort,
    toggleNumberSort,

    descriptionSort,
    toggleDescriptionSort,

    getArrow,
    getFilteredData,
  } = useClickFilter();

  // Combine search and click filters
  const getFilteredAndSortedData = () => {
    if (!data) return [];
    
    const searchFiltered = getFilteredSearchProjects();
    
    return getFilteredData(searchFiltered);
  };

  return (
    <div className="w-full">
      {/* Head */}
      <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto">
        <div className="flex justify-center">
          <b className="text-gray-600 text-2xl">Meldingen</b>
          <div className="relative flex-1 flex justify-end" ref={searchRef}>
              {/* Search area */}
              <div className="bg-white w-[50%] h-12 rounded-3xl flex justify-center my-auto border border-gray-200">
                <input
                  className="h-6 w-[80%] m-auto focus:outline-none"
                  onChange={(e) => setSearchEntry(e.target.value)}
                  onFocus={() => setIsSearchFocused(true)}
                  value={searchEntry}
                  placeholder="Zoeken..."
                />
              </div>

              {/* Filters */}
              {shouldShowFilters && (
                <div className="absolute top-full right-0 z-10 bg-white shadow-lg rounded-lg p-4 border border-gray-200 min-w-[50%] mt-2">
                  <b className="text-gray-600 text-xs">Filters</b>
                  <div
                    className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                  >
                    <b>Geen specefieke filters mogelijk op het moment</b>
                    <div className="flex text-xs">
                      <b>Zoeken is wel mogelijk</b>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
          <div className="w-2/12 cursor-pointer flex items-center" onClick={toggleNumberSort}>
            <b>Nummer</b>
            {numberSort && <img src={getArrow(numberSort) || ""} alt="sort" className="ml-1 w-4 h-4" />}
          </div>
          <div className="w-3/12 cursor-pointer flex items-center" onClick={toggleDescriptionSort}>
            <b>Beschrijving</b>
            {descriptionSort && <img src={getArrow(descriptionSort) || ""} alt="sort" className="ml-1 w-4 h-4" />}
          </div>
          <div className="w-2/12">
            <b>Status</b>
          </div>
        </div>
        {/* Items */}
        <div>
          {loading
            ? Array.from({ length: 8 }).map((_, index) => (
                <CustomerIncidentLoading key={index} />
              ))
            : getFilteredAndSortedData().length > 0
            ? getFilteredAndSortedData().map((item, index) => (
                <CustomerIncident
                  key={index}
                  number={item.number}
                  description={item.description}
                  status={item.status}
                  time={item.time}
                  target={item.target_date}
                  priority={item.priority}
                  calltype=""
                  line={item.line}
                  caller={item.caller_name}
                  operator={item.operator}
                  operatorgroup=""
                />
              ))
            : showNoIncidents && (
                <div className="flex justify-center items-center">
                  <b className="text-2xl m-4 text-gray-600">Klant heeft geen open meldingen</b>
                </div>
              )}
        </div>
      </div>
    </div>
  );
};

export default CustomerIncidents;
